// Header
export const DOCUMENT_TYPE = "documentTypeId";
export const DOCUMENT_ID = "parkDocumentHeaderId";
export const BILLING_MONTH_YEAR = "billingMonthYear";
export const BILLING_DATE = "billingRunDate";
export const BILLING_AMOUNT = "amount";
export const DUE_DATE = "dueDate";
export const TRANSACTION_TYPE = "transactionType";
export const GL_ACCOUNT = "glAccountId";
export const PAYMENT_TERM = "paymentTermId";
export const COMMENT = "comment";
export const POSTING_DATE = "postingDate";
export const POSTING_MONTH = "postingMonth";
export const YEAR = "postingYear";
export const LINE_ITEM_TYPE = "lineItemType";
export const INVOICE_DATE = "invoiceDate";
export const BASELINE_DATE = "baselineDate";

// line items
export const LINE_ITEMS = "lineItems";
export const CHECK = "check";
export const BILLING_CATEGORY = "billingCategory";
export const PROPERTY_MODEL = "propertyModelName";
export const PROPERTY_BLOCK = "blockName";
export const PROPERTY_ID = "propertyId";
export const UNIT_NO = "unitNumber";
export const STREET_ADDRESS = "addressLine1";
export const CURR_OWNER_ID = "ownershipId";
export const CURR_OWNER_NAME = "ownerName";
export const DRCR = "drCr";
export const LINE_BILLING_AMOUNT = "amount";
export const PROPERTY = "property";
export const JE_MASTER_ID = "jeMasterId";
export const ITEM_TEXT = "itemText";

export const PROPERTY_OWNERSHIP_ID = "propertyOwnershipId";
export const GL_MASTER_ID = "glMasterId";
export const BILLING_CATEGORY_ID = "billingCategoryId";
export const BUDGET_START_MONTH = "budgetMonthStart";
export const BUDGET_END_MONTH = "budgetMonthEnd";
export const BUDGET_YEAR = "budgetYear";

export const drcrOptions = [
  { label: "Dr", value: "DR" },
  { label: "Cr", value: "CR" },
];
